import _ from "lodash"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";

import { useAppDispatch } from "../../../hooks/hooks";
import { programs } from "../../../redux/programs/action";
import { selectProgramsListItems } from "../../../redux/programs/selector";
import { SubscriptionCardStyle3 } from "./subscription-card-style3";
import AccountSettings from "../../../components/venture/AccountSettings";



export const PurchasePrograms = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch()
  const [dbaasProgram, setDBaasProgram] = useState<any>([]);
  const itemsData = useSelector(selectProgramsListItems)
 
    useEffect(() => {
      dispatch(programs.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/list`,entity:'programs',jsonData:{
         }})).then(()=>{
    })}, [])
    useEffect(() => {
      setDBaasProgram(itemsData?.result?.items);
  }, [itemsData]);

  const subscribe = (item: any) => {
    navigate(`${item?.Id}`)
  }
  return (
    
      <div className="h-screen flex flex-col justify-between items-stretch bg-white">
      <div className="flex flex-row ">
      <AccountSettings />
   <div className="w-3/4">
    <div className="w-full bg-white  h-full">
        <div aria-hidden="true" className="absolute inset-0 h-max w-full m-auto grid grid-cols-2  opacity-20 pointer-events-none">
          <div className="blur-[106px] h-56 bg-gradient-to-br to-purple-200 from-blue-200"></div>
          <div className="blur-[106px] h-32 bg-gradient-to-r from-cyan-200 to-indigo-200"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 md:px-12 xl:px-6">
          <div className="mb-10 space-y-4 px-6 md:px-0">
            <h2 className="text-center text-2xl font-bold text-gray-800 sm:text-3xl md:text-4xl">Subscriptions</h2>

          </div>
          <div className="grid xl:grid-cols-3 sm:grid-cols-4 grid-cols-2 gap-4 mb-[46px]">
            {dbaasProgram && _.map(dbaasProgram, (item: any) => (
              <SubscriptionCardStyle3 subscription={item} subscribe={subscribe} />
            ))}
          </div>
        </div>
      </div>
   </div>
      
      </div>
      </div>
      
    
  )
}